import { render, staticRenderFns } from "./ManageVisits.vue?vue&type=template&id=2a6dc10c&"
import script from "./ManageVisits.vue?vue&type=script&lang=js&"
export * from "./ManageVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2a6dc10c', component.options)
    } else {
      api.reload('2a6dc10c', component.options)
    }
    module.hot.accept("./ManageVisits.vue?vue&type=template&id=2a6dc10c&", function () {
      api.rerender('2a6dc10c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/CommercialManagement/ManageVisits.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/CommercialManagement/ManageVisits.vue
// module id = zHoO
// module chunks = 0